import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import {GeneralRoute} from "../router/GeneralRoute";
import FontLoader from '../component/font_loader/FontLoader';

function App() {
    return (
        <FontLoader>
            <div className="App">
                <GeneralRoute/>
            </div>
        </FontLoader>
    );
}

export default App;
